import Information16 from '@carbon/icons-react/es/information/16';
import Insert16 from '@carbon/icons-react/es/insert/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';

const EndIconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: var(--spacing-02);
`;

export const DependentTasksTitle: FC<{ noOfItems?: number | undefined }> = ({
  noOfItems,
}) => (
  <PanelHeaderTitle
    icon={<IconShell icon={<Insert16 />} />}
    title={<FormattedMessage id="dependent_tasks" />}
    noOfItems={noOfItems}
    endIcon={
      <EndIconContainer>
        <Tooltip
          title={<FormattedMessage id="blocking_tasks.add.tooltip_content" />}
        >
          <Information16 />
        </Tooltip>
      </EndIconContainer>
    }
  />
);
